import React from "react";
import { IcoCheckCircle, IcoAlert, IcoInfo } from "./Icons";

const ICONS = {
  success: IcoCheckCircle,
  warning: IcoAlert,
  error: IcoAlert,
  info: IcoInfo,
};

// Các thông báo cũ mở đầu bằng emoji (🎉, ❌, 🗑…). Thông báo mới đã có icon
// theo loại, nên phần ký hiệu đầu câu được bỏ khi hiển thị.
const stripLeadingSymbols = (text) =>
  String(text || "").replace(/^[^\p{L}\p{N}"“(]+/u, "");

export default function NotifyCenter({ message, type = "success" }) {
  const Icon = ICONS[type] || IcoInfo;
  return (
    <div className={`toast ${type}`} role="status" aria-live="polite">
      <Icon size={18} />
      <span>{stripLeadingSymbols(message)}</span>
    </div>
  );
}
